import React from "react";
import Section from "components/presentation/main/layout/Section";
import Content from "components/presentation/main/layout/Content";
import { AnimatedContainer } from "components/presentation/main/layout/SolutionBackground";

// Sections that fill the shell instead of sitting inside its centered column: both are a
// working screen with their own toolbar, not a page of content to read.
const FULLSCREEN_SECTIONS = ["brief"];

const Layout = ({
  components,
  views,
  currentView,
  flow,
  showTopnav = true,
}) => {

  const visibleViews = (views || []).filter((view) => !view.is_hidden);
  const activeView = getActiveView(currentView, visibleViews);
  const backgroundType = components?.[activeView?.name]?.background || "ANIMATED";

  if (!activeView) return null;

  const content = <Content
    components={components}
    currentView={activeView}
    views={views}
    flow={flow}
  />;

  const sectionContent = <Section
    view={activeView}
    position="CENTER"
    isCollapsed={false}
    weight={parseInt(activeView?.settings?.weight ?? activeView?.width) || 1}
    toggleCollapse={() => {}}
  >
    {content}
  </Section>;

  if (activeView?.name === "main") {
    return (
      <BackgroundWrapper type={backgroundType} showTopnav={showTopnav} flow={flow}>
        {content}
      </BackgroundWrapper>
    );
  }

  return (
    <BackgroundWrapper type={backgroundType} showTopnav={showTopnav} flow={flow}>
      {backgroundType === "ANIMATED"
        ? <div
          className={"section-container " +
            (FULLSCREEN_SECTIONS.includes(activeView?.name) ? "section-fullscreen " : " ")}
          style={activeView?.name === "agent" ? { maxWidth: "none", paddingLeft: 0, paddingRight: 0 } : undefined}
        >
          {sectionContent}
        </div>
        : sectionContent}
    </BackgroundWrapper>
  );

};

const BackgroundWrapper = ({ type, showTopnav = true, flow, children }) => {

  if (type === "ANIMATED") return (
    <AnimatedContainer flow={flow} showTopnav={showTopnav}>
      {children}
    </AnimatedContainer>
  );

  if (type === "CARD") return (
    <div className="px-3 px-sm-4 py-1 d-flex flex-column justify-content-between w-100 h-100">
      <div className="section-container">
        {children}
      </div>
    </div>
  );

  return children;

}

// Sections are the platform's own screens. The project's app is not one of them: it is
// what the "main" section renders, so it never shows up here.
const getActiveView = (currentView = {}, visibleViews) => {
  const sections = visibleViews.filter((view) => view.is_prebuilt);
  const currentSection = sections.find((view) => view.name === currentView.name);

  if (currentSection)
    return { ...currentSection, ...currentView };

  const fallbackView = sections[0] || currentView;
  return { ...fallbackView, ...currentView, name: fallbackView?.name || currentView.name };
}

export default Layout;
